"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessageOpened = exports.INBOX_MARK_MESSAGE_OPENED = void 0;
var INBOX_MARK_MESSAGE_OPENED = "inbox/MARK_MESSAGE_OPENED";
exports.INBOX_MARK_MESSAGE_OPENED = INBOX_MARK_MESSAGE_OPENED;

var markMessageOpened = function markMessageOpened(messageId) {
  return {
    type: INBOX_MARK_MESSAGE_OPENED,
    payload: {
      messageId: messageId
    }
  };
};

exports.markMessageOpened = markMessageOpened;